// repo: https://vuemc.io/#basic-usage
import Vue from 'vue'
import {Model, Collection} from 'vue-mc'
import {Program} from "./program";
import {RegistrationAddon} from "./registration_addon";
import {RegistrationSection} from "./registration_section";
import {RegistrationSectionOption} from "./registration_section_option";

const STATES          = ['completed', 'listed_canceled', 'correction_required']
const PAYMENT_STATES  = ['none', 'completed', 'partial', 'refunded', 'partial_refunded']
const APPROVAL_STATES = ['none', 'approved', 'not_approved']
const STATE_OPTIONS         = STATES.map(state=> [state, _=>I18n.t(`app.registration.state.${state}`) ])
const PAYMENT_STATE_OPTIONS = PAYMENT_STATES.map(state=> [state, _=>I18n.t(`app.registration.payment_state.${state}`) ])
const APPROVAL_OPTIONS      = APPROVAL_STATES.map(state=> [state, _=>I18n.t(`app.registration.approval.${state}`) ])

class Registration extends Model {
  defaults() {
    return {
      id:   null,
      loaded: false,
      state: 'draft',
      owner_type: "User",
      preview: false,
      registration_form_blocks: [],
      registration_agreements: [],
      registration_addons: [],
      registration_sections: [],
      registration_section_options: [],
      registration_comments: [],
      program: {},
      person_id: null,
      place_booked: null,
      person: {},
      payments: [],
      name_changable: false,
      may_be_free_loc: null,
      renewable_loc: null,
      has_spaces_loc: null,
      can_checkout_loc: null,
      personCustomFields: {},
      invite: {},
      touch: 0,
    }
  }
  mutations() {
    return {
      id:   (id) => Number(id) || null,
      person_id:   (id) => Number(id) || null,
      state: String,
      preview: Boolean,
      program: (hash)=>{ return new Program(hash)},
      registration_addons: (arr)=>{ return arr.map(e=>{const o=new RegistrationAddon(e);o.registration=this;return o})},
      registration_sections: (arr)=>{this._lookupRSOs=null; return arr.map(e=>{const o=new RegistrationSection(e);o.registration=this;return o})},
      registration_section_options: (arr)=>{ this._lookupRSOs=null; return arr.map(e=>{const o=new RegistrationSectionOption(e);o.registration=this;return o})},
      administrative_fee_value: (sum) => Number(sum)|| null,
      deposit: (sum) => Number(sum)|| null,
      balance: (sum) => Number(sum)|| null,
      total: (sum) => Number(sum)|| null,
    }
  }
  routes() {
    return {
      fetch: '/registrations/{id}',
      save:  '/registrations',
    }
  }

  setPerson(arr, person_id){
    this.person = arr.findById(person_id) // will be empty hash if nothing found
    this.person.grades = []

    this.person_id = person_id
    if (this.person_id) this.setGrade()
    this.setCustomFields()
  }
  // fillPersonData(clean_people){
  //   const ids = (this.program.participantFormPart().form_blocks||[]).map(fb=>fb.id)
  //   for (const rfb of this.registration_form_blocks){
  //     if (ids.includes(rfb.form_block_id)){
  //       this.fillFBData(this.person_id, rfb, clean_people)
  //       if      (rfb.entity_type==='Person')           rfb.entity_id = this.person_id
  //       else if (rfb.entity_type==='PersonGraduation' || (rfb.form_block||{}).style === 'Product::FormBlock::PartPersonSchool'){
  //         // fix vue reactivity
  //         rfb.entity_attrs = this.clone_obj(rfb.entity_attrs)
  //         rfb.entity_attrs.id = rfb.entity_id // unset person attrs
  //       }
  //     }else{
  //       rfb.entity_attrs = {id: rfb.entity_id}
  //       rfb.entity_id    = rfb.entity_attrs.id
  //     }
  //   }
  // }

  // clone_obj(obj){
  //   return JSON.parse(JSON.stringify(obj))
  // }

  // fillFBData(val, rfb, clean_people){
  //   if (val === -1 || clean_people.length === 0){
  //     rfb.entity_attrs = {}
  //   }else{
  //     rfb.entity_attrs = this.person
  //   }
  // }

  async setGrade(){
    if (this.person_id < 1 || !this.person_id) return
    this._grade_promise ||= {}
    if (this._grade_promise[this.person_id]) return this._grade_promise[this.person_id]

    this._grade_promise[this.person_id] = Vue.axios.get(
  `/api2/family/people/${this.person_id}`, {params: {
      organization_id: this.program.organization_id,
      include: ["grades"]
    }})

    const object =  (await this._grade_promise[this.person_id]).data.object
    this.person.grades = object ? object.grades : []
  }


  async setCustomFields(){
    if (!this.person_id || this.person_id<1 || !this.person){
      for (const rfb of this.registration_form_blocks) rfb.custom_attrs = {}
    }else{
      const custom_map  = this.person.custom_fields.reduce((hash,cf)=>{hash[cf.custom_field_id]=cf; return hash}, {})
      this.personCustomFields = custom_map

      let fb_custom_ids = {}
      for (const fp of this.program.form_parts){
        for (const fb of fp.form_blocks) fb_custom_ids[fb.id] = fb.custom_field_ids
      }

      for (const rfb of this.registration_form_blocks){
        const custom_ids = fb_custom_ids[rfb.form_block_id]
        for (const custom_id of custom_ids){
          Vue.set(rfb.custom_attrs, custom_id+'',  custom_map[custom_id] ? custom_map[custom_id].values : [] )
        }
      }
    }
  }

  disable_reg_block (current_organization, sections=null){
    if (current_organization && current_organization.id) return false; // Not blocking anything if we are org.
    if (this.preview)                                    return false; // it's preview. Allow everything
    if (this.isStillPending())                           return false; // We are family user and registration is not finished. So no disabling

    if(sections && this.program.allow_users_to_edit_sections && this.program.registration_open()){
      // Only for sections. If program has allow_users_to_edit_sections == true. This is for allowing users edit sections if reg is still open.
      // program registration should be still open.
      return false;
    }
    return true;
  }

  lookupRSOs(section_id){
    if (this._lookupRSOs) return this._lookupRSOs[section_id] || []

    this._lookupRSOs = this.registration_section_options.reduce((hash,rso)=>{
      if (!hash[rso.section_option.section_id]) hash[rso.section_option.section_id] = []
      hash[rso.section_option.section_id].push(rso)
      return hash
    },{})

    return this._lookupRSOs[section_id] || []
  }

  isDraft(){
    return this.state === "draft"
  }
  isCorrectionRequired(){
    return this.state === "correction_required"
  }
  isStillPending(){
    return ["draft","pending","expired"].includes(this.state)
  }
  isPersisted(){
    return !!this.id
  }
  isCompleted(){
    return this.state === "completed"
  }
  isCanceled(){
    return ["canceled", "listed_canceled"].includes(this.state)
  }
  if_balance(){
    return this.balance && this.balance > 0
  }
  if_total(){
    return this.total && this.total > 0
  }
  if_deposit(){
    return this.deposit && this.deposit > 0
  }
  can_cancel(){
    return !this.program.registration_open() || !this.isCanceled() && !this.payments.some(p => p.provider_type !== "Offline")
  }
  renewable(){
    if(this.renewable_loc) return this.renewable_loc
    //cannot renew if done (completed)
    //but can renew if place_booked ot has places

    this.renewable_loc = this.place_booked || (this.isStillPending() && this.has_spaces())
    return  this.renewable_loc
  }
  has_spaces(){
    if(this.has_spaces_loc) return this.has_spaces_loc
    let res = true
    let c_ids = this.registration_section_options.flatMap(rso => rso.choice_ids)

    if(this.registration_sections.find(rs => !this.obj_has_spaces(rs.section))){ res = false}
    if(this.registration_section_options.find(rso => !this.obj_has_spaces(rso.section_option))){ res = false}
    let choices = this.program.sections.flatMap(s => s.section_options).flatMap(so => so.choices).filter(c=> c_ids.includes(c.id) )
    if(choices.find(choice => !this.obj_has_spaces(choice))){ res = false}
    this.has_spaces_loc = res

    return this.has_spaces_loc

  }
  may_be_free(){ //returns true if currently full but may be free in future
    if(this.may_be_free_loc) return this.may_be_free_loc
    if(this.place_booked) return false
    //if section has spaces set and reg count is not in max but places booked is full
    //so if spaces is nil, then section always free
    this.may_be_free_loc = this.registration_sections.find(rs=> rs.section.spaces && rs.section.spaces > rs.section.registrations_count && rs.section.spaces <= rs.section.places_booked)
    return this.may_be_free_loc
  }
  obj_has_spaces(obj){
    return obj.spaces === null || obj.spaces > obj.registrations_count
  }
  deposit_paid(){
    return this.program.deposit_required() && this.in_deposit_states()
  }
  in_deposit_states(){
    return this.payment_state === "partial" || this.payment_state === "void"
  }
  can_checkout(){
    if(this.can_checkout_loc) return this.can_checkout_loc

    let deposit_paid = ((this.program.deposit_allowed === true || this.program.deposit_allowed === 'true')
        && this.program.overdeposit_payment_method === 'offline') &&
        (this.payment_state === "partial" || this.payment_state === "void")
    this.can_checkout_loc = (parseFloat(this.total) > 0 ? parseFloat(this.balance) > 0 : !this.isCompleted()) &&
        !this.isCanceled() && !deposit_paid && !this.isCorrectionRequired()
    return this.can_checkout_loc
  }
  was_paid_offline(){
    return this.payment_state === 'void' && this.total > 0
  }
  requested( no_fees = false) {
    if(no_fees) {
      if(this.first_payment_was_offline_with_fees) {
        return this.requested_to_pay || this.balance
      } else {
        return this.requested_to_pay_without_fees || this.balance
      }
    } else {
      return this.requested_to_pay || this.balance
    }
  }
  allow_edit_sections(){
    if (this._allow_edit_sections){
      return this._allow_edit_sections;
    }else{
      return this._allow_edit_sections =
          this.program.allow_users_to_edit_sections && ['correction_required', 'completed'].includes(this.state) && this.program.registration_open()
    }
  }
  policies (){
    return this.registration_agreements.filter(ra => ra.agreement.agreement_type === 'policy')
  }
  agreements (){
    return this.registration_agreements.filter(ra => ra.agreement.agreement_type === 'agreement')
  }
  find_rblock(form_block, main){
    this._cache_find_rblock ||= {}
    if (this._cache_find_rblock[form_block.id]) return this._cache_find_rblock[form_block.id]

    const rfb = this.registration_form_blocks.find(rfb=>{
      if (rfb.form_block_id===form_block.id){
        if (main) rfb.entity_id = main.entity_id
        rfb.form_block = form_block
        return true;
      }else return false;
    })

    return this._cache_find_rblock[form_block.id] = rfb || {}
  }

  // needs for medications only
  // as one form_block may have several r_form_blocks
  find_all_rblocks(form_block){
    return this.registration_form_blocks.filter(rfb=>{
      if (rfb.form_block_id===form_block.id){
        rfb.form_block = form_block
        return true;
      }else return false;
    })
  }

  // update_reg_form_blocks(object={}){
  //   for(let rfb of this.registration_form_blocks){
  //     if (rfb.entity_id === object.id){
  //       rfb.entity_attrs = {...rfb.entity_attrs, ...object}
  //     }
  //   }
  // }

  doTouch(){
    this.touch = new Date().getTime()
  }
}

export {
  Registration,
  STATES,
  PAYMENT_STATES,
  APPROVAL_STATES,
  STATE_OPTIONS,
  PAYMENT_STATE_OPTIONS,
  APPROVAL_OPTIONS,
}
